export const VIBE_CODING_GENERATE_VIBE_RESPONSE_BEGIN = 'VIBE_CODING_GENERATE_VIBE_RESPONSE_BEGIN';
export const VIBE_CODING_GENERATE_VIBE_RESPONSE_SUCCESS =
  'VIBE_CODING_GENERATE_VIBE_RESPONSE_SUCCESS';
export const VIBE_CODING_GENERATE_VIBE_RESPONSE_FAILURE =
  'VIBE_CODING_GENERATE_VIBE_RESPONSE_FAILURE';
export const VIBE_CODING_GENERATE_VIBE_RESPONSE_DISMISS_ERROR =
  'VIBE_CODING_GENERATE_VIBE_RESPONSE_DISMISS_ERROR';
export const VIBE_CODING_GENERATE_VIBE_RESPONSE_EVENT = 'VIBE_CODING_GENERATE_VIBE_RESPONSE_EVENT';
export const VIBE_CODING_STOP_GENERATION = 'VIBE_CODING_STOP_GENERATION';

export const VIBE_CODING_GET_CONVERSATIONS_BEGIN = 'VIBE_CODING_GET_CONVERSATIONS_BEGIN';
export const VIBE_CODING_GET_CONVERSATIONS_SUCCESS = 'VIBE_CODING_GET_CONVERSATIONS_SUCCESS';
export const VIBE_CODING_GET_CONVERSATIONS_FAILURE = 'VIBE_CODING_GET_CONVERSATIONS_FAILURE';
export const VIBE_CODING_GET_CONVERSATIONS_DISMISS_ERROR =
  'VIBE_CODING_GET_CONVERSATIONS_DISMISS_ERROR';

export const VIBE_CODING_GET_CONVERSATION_HISTORY_BEGIN =
  'VIBE_CODING_GET_CONVERSATION_HISTORY_BEGIN';
export const VIBE_CODING_GET_CONVERSATION_HISTORY_SUCCESS =
  'VIBE_CODING_GET_CONVERSATION_HISTORY_SUCCESS';
export const VIBE_CODING_GET_CONVERSATION_HISTORY_FAILURE =
  'VIBE_CODING_GET_CONVERSATION_HISTORY_FAILURE';
export const VIBE_CODING_GET_CONVERSATION_HISTORY_DISMISS_ERROR =
  'VIBE_CODING_GET_CONVERSATION_HISTORY_DISMISS_ERROR';

export const VIBE_CODING_CLEAR_CONVERSATION_HISTORY_BEGIN =
  'VIBE_CODING_CLEAR_CONVERSATION_HISTORY_BEGIN';
export const VIBE_CODING_CLEAR_CONVERSATION_HISTORY_SUCCESS =
  'VIBE_CODING_CLEAR_CONVERSATION_HISTORY_SUCCESS';
export const VIBE_CODING_CLEAR_CONVERSATION_HISTORY_FAILURE =
  'VIBE_CODING_CLEAR_CONVERSATION_HISTORY_FAILURE';
export const VIBE_CODING_CLEAR_CONVERSATION_HISTORY_DISMISS_ERROR =
  'VIBE_CODING_CLEAR_CONVERSATION_HISTORY_DISMISS_ERROR';

export const VIBE_CODING_PLAN_SUCCESS = 'VIBE_CODING_PLAN_SUCCESS';
export const VIBE_CODING_PLAN_FAILURE = 'VIBE_CODING_PLAN_FAILURE';

export const VIBE_CODING_WORKSPACE_BEGIN = 'VIBE_CODING_WORKSPACE_BEGIN';
export const VIBE_CODING_WORKSPACE_SUCCESS = 'VIBE_CODING_WORKSPACE_SUCCESS';
export const VIBE_CODING_WORKSPACE_FAILURE = 'VIBE_CODING_WORKSPACE_FAILURE';

export const VIBE_CODING_WORKSPACE_FILE_BEGIN = 'VIBE_CODING_WORKSPACE_FILE_BEGIN';
export const VIBE_CODING_WORKSPACE_FILE_SUCCESS = 'VIBE_CODING_WORKSPACE_FILE_SUCCESS';
export const VIBE_CODING_WORKSPACE_FILE_FAILURE = 'VIBE_CODING_WORKSPACE_FILE_FAILURE';

export const VIBE_CODING_WORKSPACE_SAVE_BEGIN = 'VIBE_CODING_WORKSPACE_SAVE_BEGIN';
export const VIBE_CODING_WORKSPACE_SAVE_SUCCESS = 'VIBE_CODING_WORKSPACE_SAVE_SUCCESS';
export const VIBE_CODING_WORKSPACE_SAVE_FAILURE = 'VIBE_CODING_WORKSPACE_SAVE_FAILURE';

export const VIBE_CODING_LOAD_WORKSPACE_BEGIN = 'VIBE_CODING_LOAD_WORKSPACE_BEGIN';
export const VIBE_CODING_LOAD_WORKSPACE_SUCCESS = 'VIBE_CODING_LOAD_WORKSPACE_SUCCESS';
export const VIBE_CODING_LOAD_WORKSPACE_FAILURE = 'VIBE_CODING_LOAD_WORKSPACE_FAILURE';

export const VIBE_CODING_PREVIEW_ENSURE_BEGIN = 'VIBE_CODING_PREVIEW_ENSURE_BEGIN';
export const VIBE_CODING_PREVIEW_ENSURE_SUCCESS = 'VIBE_CODING_PREVIEW_ENSURE_SUCCESS';
export const VIBE_CODING_PREVIEW_ENSURE_FAILURE = 'VIBE_CODING_PREVIEW_ENSURE_FAILURE';

export const VIBE_CODING_FILE_CHANGE_BEGIN = 'VIBE_CODING_FILE_CHANGE_BEGIN';
export const VIBE_CODING_FILE_CHANGE_SUCCESS = 'VIBE_CODING_FILE_CHANGE_SUCCESS';
export const VIBE_CODING_FILE_CHANGE_FAILURE = 'VIBE_CODING_FILE_CHANGE_FAILURE';

//Non Redux related
export const VIBE_DEFAULT_BLUEPRINT = 'micro_saas';
export const PLAN_STATUS = {
  AWAITING_APPROVAL: 'awaiting_approval',
  EXECUTING: 'executing',
  STOPPED: 'stopped',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

export const VIBE_PROGRESS_STEPS = [
  { id: 'understand_plan', title: 'Understanding your idea' },
  { id: 'prepare_workspace', title: 'Setting up your app' },
  { id: 'build_ui', title: 'Designing and building your pages' },
  { id: 'connect_data', title: 'Connecting your data' },
  { id: 'interactions', title: 'Adding interactive features' },
  { id: 'verify', title: 'Checking your app' },
];

export const VIBE_CODING_THINKING_LEVELS = [
  { id: 'none', label: 'None', description: 'No reasoning — fastest responses.' },
  { id: 'low', label: 'Low', description: 'Light reasoning — quick drafts and small tweaks.' },
  { id: 'medium', label: 'Medium', description: 'Balanced reasoning for most app builds.' },
  { id: 'high', label: 'High', description: 'Deep reasoning for multi-file features.' },
  { id: 'xhigh', label: 'Extra High', description: 'Very deep reasoning, slower responses.' },
  { id: 'max', label: 'Max', description: 'Maximum reasoning — hardest problems.' },
];

export const VIBE_CODING_MODELS = [
  {
    id: 'openai/gpt-5.6-sol',
    provider: 'openai',
    label: 'GPT-5.6 Sol',
    providerLabel: 'OpenAI',
    description: 'Flagship OpenAI model for complex reasoning and coding.',
    supportedThinking: ['none', 'low', 'medium', 'high', 'xhigh', 'max'],
    defaultThinking: 'medium',
  },
  {
    id: 'openai/gpt-5.6-luna',
    provider: 'openai',
    label: 'GPT-5.6 Luna',
    providerLabel: 'OpenAI',
    description: 'Fast, cost-efficient OpenAI model.',
    supportedThinking: ['none', 'low', 'medium', 'high', 'xhigh', 'max'],
    defaultThinking: 'medium',
  },
  {
    id: 'anthropic/claude-sonnet-5',
    provider: 'anthropic',
    label: 'Claude Sonnet 5',
    providerLabel: 'Anthropic',
    description: 'Anthropic model for coding, agents and careful edits.',
    supportedThinking: ['low', 'medium', 'high', 'xhigh', 'max'],
    defaultThinking: 'high',
  },
];

export const VIBE_DEFAULT_MODEL_ID = 'openai/gpt-5.6-luna';

const getModel = (id) =>
  VIBE_CODING_MODELS.find((model) => model.id === id) ||
  VIBE_CODING_MODELS.find((model) => model.id === VIBE_DEFAULT_MODEL_ID);

export const getDefaultThinkingForModel = (modelId) => getModel(modelId).defaultThinking;

export const getThinkingOptionsForModel = (modelId) => {
  const { supportedThinking } = getModel(modelId);
  return VIBE_CODING_THINKING_LEVELS.filter((level) => supportedThinking.includes(level.id));
};

export const resolveThinkingForModel = (modelId, thinkingId) =>
  getModel(modelId).supportedThinking.includes(thinkingId)
    ? thinkingId
    : getDefaultThinkingForModel(modelId);
